/*
 *  Document   : app.js
 *  Author     : pixelcave
 *  Description: Main entry point
 *
 *  Adapted for Dermalogic ERP:
 *  - jQuery globals loaded FIRST (window.$ and window.jQuery)
 *  - Built as IIFE via esbuild for synchronous loading
 *  - 193+ Blade files depend on jQuery being available in inline scripts
 */

// jQuery globals MUST be imported before anything else
import './jquery-globals.js';

// jQuery plugins that need window.jQuery (must come after jquery-globals)
import 'jquery.appear';

// BS4 → BS5 compatibility shim (copies data-toggle to data-bs-toggle etc.)
import './bs4-compat-shim.js';

// Import required modules (template.js imports Bootstrap 5 + SimpleBar)
import Template from './modules/template.js';

// jQuery bridges for BS4 plugin compatibility (MUST come AFTER template.js
// which imports Bootstrap 5 and registers its own jQuery plugins)
import './bs4-jquery-bridges.js';

// App extends Template
export default class App extends Template {
    constructor(options) {
        super(options);
    }
}

// Create a new instance of App
window.Dashmix = new App({ darkMode: 'off' });
